import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtEduTemplateList } from 'containers';
import { ExamTemplateMenu, MyPageTitle, MyPageTemplate } from 'components';

class CtEduTemplate extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <MyPageTemplate className="table">
        <MyPageTitle
          templatePage="templatePage"
          title={defineMessages(formatMessage({ id: 'MyPageMenu_11', defaultMessage: '교육 템플릿' }))}>
          {/* <ExamTemplateMenu /> */}
        </MyPageTitle>
        <CtEduTemplateList />
      </MyPageTemplate>
    );
  }
}

CtEduTemplate.propTypes = {};
CtEduTemplate.defaultProps = {};

export default injectIntl(CtEduTemplate);



// WEBPACK FOOTER //
// ./src/script/containers/eduTemplate/CtEduTemplate.js